import Actions from "../actions";
import { produce } from "immer";
import { store } from "../store";
import { appConfig } from "../../constants/config/appConfig";
import { appAssetsConfig } from "../../constants/config/appAssetsConfig";

const initialState = {
  serviceProviderUserChat: {
    data: [],
  },
  serviceProviderUserChatRequest: {
    data: [],
  },
  serviceProviderUserChatDetailsById: {},
  serviceProviderUserChatMessages: [],
  serviceProviderChatMessagesRequestById: {},
};

const serviceProviderUserChat = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_SERVICE_PROVIDER_USER_CHAT_LIST: {
      const serviceProviderUserChat = {
        ...payload?.serviceProviderUserChat,
        data: payload?.serviceProviderUserChat?.data?.map((element) => {
          return {
            ...element,
            to_user: {
              avatar:
                element?.to_user?.profile_image ||
                appAssetsConfig.DEFAULT_PROFILE_IMAGE,
              title: `${element?.to_user?.first_name} ${element?.to_user?.last_name}`,
              subtitle: element?.last_message?.message,
              date: new Date(element?.last_message?.created_at)?.toISOString(),
              role: element?.to_user?.role,
              to_id: element?.to_user?._id,
              _id: element?._id,
              last_message: {
                ...element?.last_message,
              },
              unread : element?.unread_messages_count
            },
          };
        }),
      };
      draft.serviceProviderUserChat = serviceProviderUserChat;
      break;
    }

    case Actions.GET_SERVICE_PROVIDER_USER_CHAT_REUQEST_LIST: {
      const serviceProviderUserChatRequest = {
        ...payload?.serviceProviderUserChatRequest,
        data: payload?.serviceProviderUserChatRequest?.data?.map((element) => {
          return {
            ...element,
            customer_id: {
              avatar:
                element?.customer_id?.profile_image ||
                appAssetsConfig.DEFAULT_PROFILE_IMAGE,
              title: `${element?.customer_id?.first_name} ${element?.customer_id?.last_name}`,
              date: new Date(element?.created_at).toISOString(),
              customer_id: element?.customer_id?._id,
              _id: element?._id,
              chat_post_id: element?.chat_post_id,
            },
          };
        }),
      };
      draft.serviceProviderUserChatRequest = serviceProviderUserChatRequest;
    }

    case Actions.GET_SERVICE_PROVIDER_USER_CHAT_DETAILS_BY_ID: {
      draft.serviceProviderUserChatDetailsById =
        payload?.serviceProviderUserChatDetailsById;
      break;
    }

    case Actions.GET_SERVICE_PROVIDER_REQUEST_DETAILS_BY_ID: {
      draft.serviceProviderChatMessagesRequestById = payload;
    }

    case Actions.GET_SERVICE_PROVIDER_USER_CHAT_MESSAGES: {
      draft.serviceProviderUserChatMessages =
        payload?.serviceProviderUserChatMessages?.messages;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default serviceProviderUserChat;
